import { FunctionComponent, useState, useEffect } from 'react';
import DashboardLayout from '../../../components/layout/layout';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDeleteUserFromChannelPartnersUserList } from '../../../hooks/api/otherextranet';

const DeleteUserFromUserList: FunctionComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id: userId } = useParams<{ id: string }>();
    const queryParams = new URLSearchParams(location.search);
    const firstName = queryParams.get('firstName') ?? '';
    const lastName = queryParams.get('lastName') ?? '';
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<boolean>();
    const [disabled, setDisabled] = useState<boolean>(false);
    const { mutateAsync: deleteCPUser } = useDeleteUserFromChannelPartnersUserList();

    useEffect(() => {
        if (userId === '' || !userId) {

            navigate(-1);
        }
    }, [userId, navigate]);

    const deleteUser = async () => {
        try {
            setDisabled(true);
            const result = await deleteCPUser({ userId: userId! });
            if (result?.status === 200) {
                setSuccess(true)
                setTimeout(() => {
                    setSuccess(false);
                    navigate(-1);
                    setDisabled(false);
                }, 3000);
            } else {
                setDisabled(false);
                setError('An error occurred during login. Please try again.');
                setTimeout(() => {
                    setError('');
                }, 3000);
            }
        } catch (err: any) {
            setDisabled(false);
            if (err?.response?.data?.message) {
                setError(err.response.data.message);
            } else if (err?.message) {
                setError(err.message);
            } else {
                setError('An error occurred during login. Please try again.');
            }
        }
    }

    return (
        <>
            <DashboardLayout
                titleIcon={<DesktopWindowsOutlinedIcon />}
                title="Other Extranet"
                initialBreadcrumbs="Extranet/Barksdale Admin"
                levelBreadcrumbs=""
                breadcrumbs="Channel Partner User Delete"
                activeMenu="overview"
            >
                <>
                    <Typography variant="body1" mb={3}>
                        Are you sure you want to delete {firstName} {lastName}?
                    </Typography>

                    <Grid size={12}>
                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                {error}
                            </Alert>
                        )}
                        {
                            success && (
                                <Alert severity="success" sx={{ mt: 2 }}>
                                    User deleted successfully!
                                </Alert>
                            )
                        }
                    </Grid>

                    <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 3 }}>
                        <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={(e) => deleteUser()}>
                            YES
                        </Button>
                        <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={() => navigate(-1)}>
                            NO
                            <Alert severity="success" sx={{ mt: 2 }}>
                                Userid: {userId}
                                firstName: {firstName}
                            </Alert>
                        </Button>
                    </Box>
                </>
            </DashboardLayout>
        </>
    )
};

export default DeleteUserFromUserList;